import {isEmpty} from 'lodash-es';
import {useState} from 'react';

import {Button, SpinningLoader} from '@/components';
import {TextArea} from '@/components/common/Input';
import type {UserModalProps} from '@/components/DeactivateAccount/types';
import Modal from '@/components/Modals';
import useReward from '@/screens/Rewards/List/useReward';

interface TierCardFormModalProps extends Pick<
  UserModalProps,
  'isOpen' | 'onClose'
> {
  cardId?: string;
  rewardId: string;
}

const TierCardFormModal = ({
  isOpen,
  onClose,
  cardId,
  rewardId,
}: TierCardFormModalProps) => {
  const [codes, setCodes] = useState('');
  const {isCardLoading: isLoading, handleAddCards} = useReward();

  const updateLabel = isEmpty(cardId)
    ? 'Add Cards To Reward Item +'
    : 'Remove Cards From Reward Item';
  const submitLabel = isEmpty(cardId) ? 'Submit' : 'Remove';
  const isDisabled = isEmpty(codes);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width="w-11/12 md:w-5/12 lg:w-4/12 xl:w-3/12 px-4 sm:px-0"
      closeOnOutsideClick
      title={updateLabel}
    >
      {isLoading ? (
        <div className="flex w-full h-full justify-center items-center my-5">
          <SpinningLoader />
        </div>
      ) : (
        <>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              // Fire-and-forget: handleAddCards catches and surfaces its own
              // failures, so this only stops an unexpected throw becoming an
              // unhandled rejection.
              handleAddCards(codes, rewardId).catch(() => {});
            }}
            className="flex flex-col space-y-5"
          >
            <div className="mt-3">
              <TextArea
                name="codes"
                label="Enter card codes"
                onChange={(e) => setCodes(e.target?.value || codes)}
                value={codes || ''}
                aria-rowspan={3}
                type="text"
                placeholder="Enter card codes one on each line"
                className="w-full"
                required
              />
            </div>

            <div className="flex w-full justify-end space-x-2 py-5">
              <Button
                type="button"
                onClick={onClose}
                variant="outline"
                colorScheme="cyan"
              >
                Cancel
              </Button>

              <Button
                disabled={isDisabled}
                type="submit"
                variant="solid"
                colorScheme="cyan"
              >
                {submitLabel}
              </Button>
            </div>
          </form>
        </>
      )}
    </Modal>
  );
};

export default TierCardFormModal;
